import React from "react";
import { Button } from "../../../../ui/components/Button";
import { BillListStatus } from "../../domain";
import { BILL_STATUS_OPTIONS } from "../utils/billListStatus";

interface BillStatusFilterPillsProps {
  value: BillListStatus;
  onChange: (value: BillListStatus) => void;
}

export const BillStatusFilterPills: React.FC<BillStatusFilterPillsProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {BILL_STATUS_OPTIONS.map((option) => (
        <Button
          key={option.value}
          variant={value === option.value ? "brand-primary" : "neutral-secondary"}
          size="small"
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};
